<template lang="html">
  <section class="error-banner">

    <div class="banner row-center" :show="!!code" :type="isFatal">

      <div class="popup" :style="ownstyles.popup">

        <a class="cerrar -small" @click="eraseError" v-if="!!error && !!!error[lang].to"
          v-show="error.categoria != 'important'">✕</a>

         <!-- ERROR CUSTOM -->
         <template v-if="!!custom">
          <h2 class="title-dato">{{custom.titulo}}</h2>
          <p v-html="custom.mensaje"></p>
          <a class="btn -solid-primary" v-if="custom.customButtonLabel != null"  target='_blank' :href="custom.customButtonClick">{{custom.customButtonLabel}}</a>
          <a @click="goTo(custom)" class="btn -solid-primary" v-else>
            <template>{{$t('aceptar')}}</template>
          </a>
        </template>


        <!-- ERRORES PREDEFINIDOS -->
        <template v-else>

          <h2 class="title-dato" v-if="!!error">{{ error[lang].titulo }}</h2>

          <p v-if="!!error && !!!mensaje" v-html="error[lang].cuerpo"></p>

          <p v-if="!!error && !!!mensaje" class="negrita">{{error[lang].aviso}}</p>
          <p v-if="!!error && !!mensaje" v-html="mensaje"></p>
          <template v-if="!onlyErase">

            <a @click="exit" v-if="!!error" v-show="error.categoria == 'important' && !!!error[lang].to" to="/"
              class="btn -solid-primary">{{ (!!error[lang].btn_text) ? error[lang].btn_text : $t('aceptar') }}</a>

            <a @click="eraseError" v-if="!!error" v-show="error.categoria != 'important' && !!!error[lang].to"
              class="btn -solid-primary">{{ (!!error[lang].btn_text) ? error[lang].btn_text : $t('aceptar') }}</a>

            <a @click="goTo(error[lang])" v-if="!!error" v-show="!!error[lang].to"
              class="btn -solid-primary">{{ (!!error[lang].btn_text) ? error[lang].btn_text : $t('aceptar') }}</a>

          </template>
          <template v-else>
            <a @click="exit" v-if="!!error" v-show="error.categoria == 'important' && !!!error[lang].to" to="/logout"
              class="btn -solid-primary">{{(!!error[lang].btn_text) ? error[lang].btn_text : 'Aceptar'}}</a>
          </template>
        </template>
      </div>

    </div>

  </section>
</template>

<script lang="js">

import { mapGetters, mapActions } from 'vuex';

import data from '@/errors';

import router from '@/router';

export default {
  name: 'error-banner',
  data() {
    return {
      errorslist: ''
    }
  },
  created() {
    this.errorslist = data;
  },
  computed: {
    ...mapGetters({
      code: 'getErrorCode',
      mensaje: 'getErrorMensaje',
      custom: 'getErrorCustom',
      lang: 'getLanguage',
      loading: 'getLoading',
      colors: 'basicColors',
      style: 'getStyles',
      isEmpresa: 'isEmpresa',
    }),
    isFatal: function () {
      let fatal;
      if (!!this.code && this.errorslist && !!this.errorslist[this.code]) {
        fatal = this.errorslist[this.code].categoria;
      }
      return fatal;
    },
    error: function () {
      let error;
      if (!!this.code) {
        error = this.errorslist[this.code];
      }
      return error;
    },
    ownstyles: function () {
      return {
        popup: {
          background: this.colors.white
        }
      }
    },
    onlyErase() {
      let views = ['ficha_encuestas'];
      let result = false;
      result = (views.some(v => v == this.$route.name));
      // (result) ? this.eraseErrorAndData() : null;
      return result;
    }
  },
  methods: {
    ...mapActions(['eraseError', 'setLoading', 'logout', 'sendInfoAboutError', 'eraseErrorAndData']),
    exit: function () {
      this.eraseError();
      router.push('/logout');
    },
    goTo: function (error) {


      this.eraseError();

      console.log(error)

      if (!!!error.blank) {
        router.push(error.to);
      } else {
        let route = this.$router.resolve({ path: error.to });
        window.open(route.href, '_blank');
      }

    },
  },
  watch: {
    'code': function () {
      let errorsToWatch = ['1', '12', '24', '500'];
      if (!!this.code) {
        if (!!!this.errorslist[this.code] | errorsToWatch.some(e => e == this.code)) {
          // this.sendInfoAboutError(this.code);
        }
      }
    },
    '$route': function () {
      if (this.code != 2) {
        this.eraseError();
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/colors.scss';

.negrita{
    font-weight: bold;
  }

.banner {
  /*display: none;*/
  display: inline-block;
}

.banner {
  position: fixed;
  right: 10px;
  bottom: -400px;
  z-index: 110;
  transition: .7s;
  transition-delay: 0s;
  display: inline-block;
}

.banner[type=secondary][show=true] {
  transform: translateY(-410px);
  transition-delay: .5s;
}


.banner[type=important],
.banner[type=medium] {
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, .80);
  z-index: 110;
  display: none;
}

.banner[type=important][show=true],
.banner[type=medium][show=true] {
  display: flex;
}




.popup {
  padding: 30px;
  text-align: center;
  min-width: 500px;
  max-width: 600px;
  box-shadow: 2px 3px 11px 1px rgba(0, 0, 0, 0.7);
  position: relative;
  .title-dato{
    text-align: center;
  }
  p {
  line-height: 20px;
  text-align: center;
}
}



.banner[type=important] .popup * {
  text-align: center;
}

.popup .cerrar {
  position: absolute;
  right: 0px;
  top: 0px;
  width: 30px;
  height: 30px;
  line-height: 30px;
}

.banner[type=secondary] .popup {
  padding: 15px;
  box-shadow: 2px 3px 11px 1px rgba(0, 0, 0, 0.3);
  max-width: 400px;
  min-width: 300px;
}

@media screen and (max-width:768px) {

  .banner {
    bottom: auto;
    top: -200px;
    right: 50%;
    left: auto;
    transform: translate(50%, 0);
    opacity: 0;
    transition: opacity 0s 0s;
  }

  .banner[type=secondary],
  .banner[type=important],
  .banner[type=medium] {
    position: fixed;
    max-width: 500px;
    width: calc(100vw - 20px);
    left: auto;
    bottom: auto;
    top: -200px;
    right: 50%;
    transform: translate(50%, 0);
    opacity: 1;
  }

  .banner[type=secondary][show=true],
  .banner[type=medium][show=true],
  {
  right: 50%;
  transform: translate(50%, 210px);
  transition: .5s;
  transition-delay: .5s;
  background: transparent;
}

.banner[type=secondary] .popup,
.banner[type=important] .popup,
.banner[type=medium] .popup {
  border-radius: 7px;
  width: 100%;
  max-width: 100%;
  background: rgba(255, 255, 255, .95);
}

.title-dato {
  font-size: 28px;
  margin-bottom: 5px;
  line-height: 1.2em;
}

p {
  margin-bottom: 0;
  font-size: 20px;
}

.banner[type=important] {
  display: none;
}

.banner[type=important][show=true] {
  background: rgba(0, 0, 0, .5);
  width: 100vw;
  max-width: 100vw;
  height: 100vh;
  display: flex;
  transform: none;
  position: fixed;
  right: 0;
  top: 0;
  padding: 20px;
}

.banner[type=important][show=true] .popup {
  max-width: 500px;
}


}

@media screen and (max-width: 540px) {
  .popup {
    min-width: 0;
    padding: 15px;
  }

  .title-dato {
    font-size: 20px;
  }

  p {
    font-size: 16px;
  }
}

.btn {
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/parts/error-banner.vue